import React, {useState} from "react";
import {useNavigate, Link} from "react-router-dom";
import { Button} from "reactstrap";

import { PDFViewer ,PDFDownloadLink } from '@react-pdf/renderer';
import {Trans, useTranslation} from "react-i18next";
import Popup from "reactjs-popup";
import Pdf from "../Assets/Pdf"
import moment from "moment";





function Final  (props) {
    const { i18n } = useTranslation();
    const d = localStorage.getItem('isDead') === "true"
    let history = useNavigate();

    const personalDetails = JSON.parse(localStorage.getItem('personalDetails'))
    const prevLocation = {
        pathname: '../information',
        state: { d: d }
    }
    const handlePrev = (e) =>{
        e.preventDefault()
        history(prevLocation)
    }
    const [Valid, setValid] = useState( false)
    const handleValid= (e) =>{
        setValid(!Valid)
    }

    const handlePrint = (e) => {
        window.frames[0].focus();
        window.frames[0].print();
    }

    const [popupOpen, setPopupOpen] = useState(false);
    const openModal = () => {
        setPopupOpen(true);
    }
    const closeModal = () => {
        setPopupOpen(false)
    }
    const [dataCleared, setDataCleared] = useState(false);
    const clearData = () => {
        localStorage.clear()
        setDataCleared(true)
        history("/"+i18n.language)
    }

    return (
        <div className={"container final"}>
            {popupOpen &&
                <Popup
                    open={popupOpen}
                    closeOnDocumentClick
                    onClose={closeModal}
                >
                    <div className={
                        "modal-content"
                    }>
                        <div className={"modal-header"}>
                        <span className="close" onClick={closeModal} >
                            &times;
                        </span>
                        </div>
                        {!dataCleared &&

                            <div className="modal-body">
                                <Trans i18nKey={"ClearData"}>
                                    <p>Etes-vous sûr que vous voulez effacer les données remplies et que votre navigateur a
                                        enregistré?</p>
                                </Trans>
                            </div>
                        }
                        {!dataCleared &&
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary danger small" onClick={closeModal}>{i18n.t('Non')}</button>
                                <button onClick={clearData}
                                        className="btn btn-primary success small">{i18n.t('Oui')}</button>
                            </div>
                        }
                        {!!dataCleared &&
                            <div className="modal-body">
                                <Trans i18nKey={"ClearedData"}>
                                    <p>Les données de vos formulaires sont effacées.</p>
                                </Trans>
                            </div>
                        }

                    </div>
                </Popup>
            }
            { !Valid &&
                <div className={d? "death" : "injured"}>
                    <div className={"text-center mb-3"}>
                        <Button color={"primary info small m-2"} className={'mr-1'} onClick={handlePrev}>{i18n.t("Modifier")}</Button>
                        <Button color={"primary success small m-2"} onClick={handleValid}>{i18n.t("Valider")}</Button>
                    </div>
                    <div className="vh" id={'frame'}>
                        <PDFViewer width={"100%"} height={"100%"}><Pdf/></PDFViewer>
                    </div>
                </div>
            }

            { Valid &&
                <div className={d? "death" : "injured"}>
                    <div className={"col-md-8 offset-md-2 text-left"}>
                        <PDFDownloadLink className={"btn btn-primary small m-2"} document={<Pdf />} fileName={moment().format('DD[-]MM[-]YYYY')+'-'+ personalDetails.Field7Name.toLowerCase()+'-accidentinfo.pdf'}>
                            {i18n.t("TELECHARGER LE PDF")}
                        </PDFDownloadLink>
                        <Button color={"primary info small m-2"} onClick={handlePrint}>{i18n.t("VERSION IMPRIMABLE")}</Button>
                        <a  className={"btn btn-primary info small m-2"} href={"https://www.e-contract.be/dss"} target='_blank' rel='noopener noreferrer'>
                            {i18n.t("SIGNER LE PDF AVEC VOTRE eID")}
                        </a>
                    </div>
                    <div  className={"col-md-8 offset-md-2 text-left"}>
                        <div className={"mx-2 mt-4"}>{i18n.t("END DELETE TEXT 1")}</div>
                        <Button color={"primary danger small m-2"} onClick={openModal}>{i18n.t("END DELETE BUTTON")}</Button>

                    </div>
                    <div className="hidden" id={'frame'}>
                        <PDFViewer width={"100%"} height={"100%"}><Pdf/></PDFViewer>
                    </div>
                </div>
            }
        </div>)

};
export default Final
